module.exports = __webpack_public_path__ + "img/1.15.A.b337133e.png";